__webpack_require__.p = "https://turborepo-game-of-life.vercel.app/";